module.exports = __webpack_public_path__ + "img/goods06.5eae8667.jpg";